// extracted by mini-css-extract-plugin
module.exports = {"section":"CMKYiA1k","title":"yxNNEITs","list":"m3sjMCmK","item":"F8sLtc8C"};